module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "white_bg",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.title != null) ? _c('div', {
    staticClass: "main_title mt_wave a_center"
  }, [_c('h2', [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v(" " + _vm._s(_vm.title[_vm.currentLanguage]) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.header != null) ? _c('p', {
    staticClass: "main_description a_center"
  }, [_vm._v(_vm._s(_vm.header[_vm.currentLanguage]))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "380px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 16,
      "sensor": false
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.center,
      "clickable": true,
      "draggable": false
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "contact-items"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-3"
  }, [_c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-map-marker"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4"
  }, [_c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-phone-alt"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.phone))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-5"
  }, [_c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.email))])])])])]), _vm._v(" "), _c('contact-form')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c708575"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/indexContactForm/ContactForm.vue
// module id = 347
// module chunks = 0